import axiosInstance from './apiConfig';

export const getAllUsers = async (organizationId?: number, search?: string) => {
  try {
    const params: Record<string, any> = {};

    if (organizationId !== undefined) {
      params.organizationId = organizationId;
    }

    if (search && search.trim().length > 0) {
      params.search = search.trim();
    }

    const response = await axiosInstance.get('/auth/getAll', { params });

    return response.data;
  } catch (error: any) {
    throw new Error(`fetch users failed ${error.response?.data?.error}`);
  }
};

export const addNewUser = async (createdBy: string, data) => {
  try {
    const response = await axiosInstance.post(
      '/auth/add?adminId=' + createdBy,
      data,
    );

    return response.data;
  } catch (error) {
    throw new Error(`add user failed ${error.response?.data?.error}`);
  }
};

export const editUserInfo = async (id: number, data) => {
  try {
    const response = await axiosInstance.put(
      '/auth/updateUser?userId=' + id,
      data,
    );

    return response.data;
  } catch (error) {
    throw new Error(`update user failed ${error.response?.data?.error}`);
  }
};

export const removeUser = async (deletedBy: string, userId: string) => {
  try {
    const response = await axiosInstance.delete(
      '/auth/delete?adminId=' + deletedBy,
      {
        data: { userId }, // Body data
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(`delete user failed ${error.response?.data?.error}`);
  }
};
